<h2 mat-dialog-title tabindex="0" class="narrow" data-test-id="create-verfuegung-dialog-title">
	Verfügung erstellen mit folgenden Aufgaben
</h2>

<form [formGroup]="form">
	<mat-dialog-content>
		<div class="wizard">
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_REGISTERAKTE_ANLEGEN)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-registerakte-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_REGISTERAKTE_ANLEGEN, $event.checked)">
					Registerakte anlegen
				</mat-checkbox>
				@if (formService.registerakteGroup.enabled) {
					<schir-int-client-aufgabe-with-notiz-editor
						[aufgabenTyp]="aufgabenTypen.LFPR_REGISTERAKTE_ANLEGEN"
						data-test-id="verfuegung-registerakte" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_SCHULDTITEL)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-schuldtitel-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_SCHULDTITEL, $event.checked)">
					Schuldtitel
				</mat-checkbox>
				@if (formService.schuldtitelGroup.enabled) {
					<schir-int-client-aufgabe-schuldtitel-editor data-test-id="verfuegung-schuldtitel" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_MITTEILUNG)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-mitteilung-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_MITTEILUNG, $event.checked)">
					Eintragungsmitteilung fertigen
				</mat-checkbox>
				@if (formService.mittelungGroup.enabled) {
					<schir-int-client-aufgabe-lfpr-mitteilung-editor data-test-id="verfuegung-mitteilung" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_STATISTIK)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-statistik-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_STATISTIK, $event.checked)">
					Statistik
				</mat-checkbox>
				@if (formService.statistikGroup.enabled) {
					<schir-int-client-aufgabe-with-notiz-editor
						[aufgabenTyp]="aufgabenTypen.LFPR_STATISTIK"
						data-test-id="verfuegung-statistik" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_VERWEISUNGSVERMERK)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-verweisungsvermerk-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_VERWEISUNGSVERMERK, $event.checked)">
					Verweisungsvermerk
				</mat-checkbox>
				@if (formService.verweisungsvermerkGroup.enabled) {
					<schir-int-client-aufgabe-with-notiz-editor
						[aufgabenTyp]="aufgabenTypen.LFPR_VERWEISUNGSVERMERK"
						data-test-id="verfuegung-verweisungsvermerk" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_DB_AKTUALISIEREN)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-db-aktualisieren-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_DB_AKTUALISIEREN, $event.checked)">
					Datenbank aktualisieren
				</mat-checkbox>
				@if (formService.dbAktualisierenGroup.enabled) {
					<schir-int-client-aufgabe-with-notiz-editor
						[aufgabenTyp]="aufgabenTypen.LFPR_DB_AKTUALISIEREN"
						data-test-id="verfuegung-db-aktualisieren" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_BLATTABSCHRIFT)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-blattabschrift-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_BLATTABSCHRIFT, $event.checked)">
					Blattabschrift
				</mat-checkbox>
				@if (formService.blattabschriftGroup.enabled) {
					<schir-int-client-aufgabe-lfpr-blattabschrift-editor data-test-id="verfuegung-blattabschrift" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_NEGATIVBESCHEINIGUNG)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-negativbescheinigung-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_NEGATIVBESCHEINIGUNG, $event.checked)">
					Negativbescheinigung erteilen
				</mat-checkbox>
				@if (formService.negativbescheinigungGroup.enabled) {
					<schir-int-client-aufgabe-with-notiz-editor
						[aufgabenTyp]="aufgabenTypen.LFPR_NEGATIVBESCHEINIGUNG"
						data-test-id="verfuegung-negativbescheinigung" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_KOSTEN)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-kosten-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_KOSTEN, $event.checked)">
					Kosten
				</mat-checkbox>
				@if (formService.kostenGroup.enabled) {
					<schir-int-client-aufgabe-lfpr-kosten-editor data-test-id="verfuegung-kosten" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_WIEDERVORLAGE)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-wiedervorlage-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_WIEDERVORLAGE, $event.checked)">
					Wiedervorlage
				</mat-checkbox>
				@if (formService.wiedervorlageGroup.enabled) {
					<schir-int-client-aufgabe-wiedervorlage-editor
						[aufgabenTyp]="aufgabenTypen.LFPR_WIEDERVORLAGE"
						data-test-id="aufgabe-wiedervorlage" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_ERLEDIGT)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-erledigt-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_ERLEDIGT, $event.checked)">
					Fall erledigt
				</mat-checkbox>
				@if (formService.erledigtGroup.enabled) {
					<schir-int-client-aufgabe-with-notiz-editor
						[aufgabenTyp]="aufgabenTypen.LFPR_ERLEDIGT"
						data-test-id="verfuegung-erledigt" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_WEGLEGEN)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-weglegen-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_WEGLEGEN, $event.checked)">
					Akte weglegen
				</mat-checkbox>
				@if (formService.weglegenGroup.enabled) {
					<schir-int-client-aufgabe-lfpr-weglegen-editor
						data-test-id="verfuegung-weglegen"
						[aufgabenTyp]="aufgabenTypen.LFPR_WEGLEGEN" />
					<hr />
				}
			}
			@if (valideAufgabenTypen.includes(aufgabenTypen.LFPR_SAMMLUNG)) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					data-test-id="verfuegung-sammlung-checkbox"
					(change)="toggleGroup(aufgabenTypen.LFPR_SAMMLUNG, $event.checked)">
					Zur Sammlung
				</mat-checkbox>
				@if (formService.sammlungGroup.enabled) {
					<schir-int-client-aufgabe-lfpr-weglegen-editor
						data-test-id="verfuegung-sammlung"
						[aufgabenTyp]="aufgabenTypen.LFPR_SAMMLUNG" />
				}
			}

			<mat-form-field appearance="outline">
				<mat-label>Notiz zur Verfügung</mat-label>
				<textarea
					matInput
					data-test-id="verfuegungs-notiz-input"
					[formControl]="formService.controlVerfuegungNotiz"></textarea>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions>
		<button
			mat-stroked-button
			(click)="onCancel()"
			type="button"
			class="focus-inwards-dark"
			data-test-id="abbrechen-button">
			Abbrechen
		</button>
		<button
			mat-flat-button
			color="primary"
			type="button"
			(click)="onSave()"
			[disabled]="!isValid()"
			class="icon-right focus-inwards-dark"
			data-test-id="speichern-button">
			Speichern
		</button>
	</mat-dialog-actions>
</form>
